<ng-container *ngIf="value !== undefined">
    <span [class.text--positive]="showColors ? isPositive(value) : null" [class.text--negative]="showColors ? !isPositive(value) : null">
        {{ text }}
    </span>
</ng-container>